// extracted by mini-css-extract-plugin
export default {"avatar":"ProfileButton_avatar__oSyte"};